import moment from 'moment';
import {
   TIMEPROOF_DOWNLOAD_PDF,
   DELETE_TIMEPROOF_REPORT,
} from '../../core/store/modules/report.timeproof';
import {
   SCREENPROOF_DOWNLOAD_PDF,
   DELETE_SCREENPROOF_REPORT,
} from '../../core/store/modules/report.screenproof';
import {
   SIGNPROOF_DOWNLOAD_PDF,
   SIGNPROOF_DELETE_REPORT,
} from '../../core/store/modules/report.signproof';
import {
   PIC_DOWNLOAD,
   PIC_DELETE
} from '../../core/store/modules/report.picscan';


export default {
   methods: {
      addSpinner(button) {
         button.classList.add("spinner", "spinner-dark", "spinner-right");
      },
      addSpinnerLight(button) {
         button.classList.add("spinner", "spinner-light", "spinner-right", "disabled");
      },
      removeSpinner(button) {
         button.classList.remove("spinner", "spinner-dark", "spinner-light", "spinner-right", "disabled");
      },
      getDownloadAction(type) {
         let action = null;
         switch (type) {
            case 'SCREENPROOF':
               action = SCREENPROOF_DOWNLOAD_PDF;
               break;
            case 'TIMEPROOF':
               action = TIMEPROOF_DOWNLOAD_PDF;
               break;
            case 'SIGNPROOF':
               action = SIGNPROOF_DOWNLOAD_PDF;
               break;
            case 'PICSCAN':
               action = PIC_DOWNLOAD;
               break;
            default:
               action = SCREENPROOF_DOWNLOAD_PDF;
               break;
         }
         return action;
      },
      getDeleteAction(type) {
         let action = null;
         switch (type) {
            case 'SCREENPROOF':
               action = DELETE_SCREENPROOF_REPORT;
               break;
            case 'TIMEPROOF':
               action = DELETE_TIMEPROOF_REPORT;
               break;
            case 'SIGNPROOF':
               action = SIGNPROOF_DELETE_REPORT;
               break;
            case 'PICSCAN':
               action = PIC_DELETE;
               break;
            default:
               action = DELETE_SCREENPROOF_REPORT;
               break;
         }
         return action;
      }
   },
   filters: {
      timeMills(date) {
         return moment(date.toMillis()).format('LT');
      },
      dateMills(date) {
         return moment(date.toMillis()).format('D MMMM YYYY');
      },
      date(date) {
         return moment(date).format('LL');
      },
      time(date) {
         return moment(date).format('LT');
      },
      limit(value, length=18) {
         return value.substr(0, length) + '...';
      },
      toUpper(value) {
         return value.toString().toUpperCase();
      }
   }
}